<!-- #58 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Add Inbound Order
        <i class="caption red--text ml-4"> * required field</i>
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card class="elevation-2" style="width: 100%">
      <v-card-text>
        <v-form ref="form" lazy-validation class="vendor">
          <v-row class="text-center py-0">
            <v-col
              md="6"
              class="mb-0 pb-0"
              v-if="next == false && userCategory.user_category === 3"
            >
              <v-autocomplete
                v-model="formData.client_id"
                :items="clients"
                :loading="clientLoader"
                hide-no-data
                hide-details
                item-text="name"
                item-value="id"
                label="Select Client"
                placeholder="Start typing to Search"
                class="required mb-0 pb-0"
                @change="
                  fetchVendor(formData.client_id),
                    fetchCurrency(formData.client_id)
                "
                :rules="[(v) => !!v || 'Please select client']"
              ></v-autocomplete>
            </v-col>
            <v-col md="6" class="pl-0 d-flex">
              <v-col md="8">
                <v-autocomplete
                  v-model="formData.vendor_code"
                  :items="vendors"
                  :loading="vendorLoader"
                  hide-no-data
                  item-text="vendor_name"
                  item-value="vendor_code"
                  label="Select Vendor"
                  placeholder="Start typing to Search"
                  class="required pt-0 mt-1"
                  :rules="[(v) => !!v || 'Please select vendor']"
                ></v-autocomplete>
              </v-col>
              <v-col md="4" class="mt-3">
                <v-btn color="info" small @click="goToVendor">Add Vendor</v-btn>
              </v-col>
            </v-col>
            <v-col md="12" class="pb-0 pt-0 d-flex">
              <v-col sm="6" class="pl-0 pt-0 pb-0">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(delivery_date)"
                      label="Delivery Date (Shipment to be received in Warehouse)"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      :rules="[(v) => !!v || 'Please select Delivery date']"
                      v-on="on"
                      class="required mt-0 pb-0 mb-0 pt-0"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="delivery_date"
                    @input="(dateMenu = false), changeDate()"
                    :min="getEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col sm="6" class="pl-0 pb-0 pt-0 mt-0">
                <v-text-field
                  label="Additional Reference Number"
                  class="mt-0 pt-0"
                  v-model="formData.additional_reference_number"
                >
                </v-text-field>
              </v-col>
            </v-col>
            <v-col md="4" class="pt-0 pb-0">
              <v-autocomplete
                v-model="formData.currency_code"
                :items="currencyList"
                hide-no-data
                item-text="name"
                item-value="name"
                label="Select Currency"
                placeholder="Start typing to Search"
                class="required"
                :rules="[(v) => !!v || 'Please select currency']"
              ></v-autocomplete>
            </v-col>
            <v-col md="4" class="pt-0 pb-0">
              <v-text-field
                label="Vendor Invoice Number"
                class="required"
                :rules="[(v) => !!v || 'Vendor Invoice Number']"
                v-model="formData.vendor_invoice_number"
              >
              </v-text-field>
            </v-col>
            <v-col md="4" class="pt-0 pb-0">
              <v-file-input
                v-model="file"
                counter
                show-size
                accept=".xlsx"
                class="required"
                label="Select file"
                :rules="[(v) => !!v || 'Please select File']"
              >
              </v-file-input>
            </v-col>
          </v-row>
          <v-btn
            color="primary"
            dark
            class="mt-6"
            small
            :loading="fileLoader"
            @click="add()"
          >
            Upload
          </v-btn>
          <v-btn
            color="info"
            class="mt-6 ml-2"
            small
            :loading="downloader"
            @click="downloadTemplate()"
            >Download template</v-btn
          >
          <v-btn small color="white" class="ml-4 mt-6" @click="reset()"
            >Cancel</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="dialog"
      max-width="550px"
      @keydown.esc="dialog = false"
      persistent
    >
      <v-card>
        <v-card-title class="px-0 py-0">
          <v-toolbar flat>
            <v-toolbar-title> Error </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon
              @click="
                dialog = false;
                ErrorMessage = '';
              "
              >mdi-close</v-icon
            >
          </v-toolbar>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          <span v-for="msg in ErrorMessage" :key="msg"
            >{{ msg.error }} <br
          /></span>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="vendorPopup"
      max-width="750px"
      @keydown.esc="vendorPopup = false"
      persistent
    >
      <v-card>
        <v-card-title class="p-0">
          <v-toolbar flat style="height: 50px">
            <v-toolbar-title class="mb-2">
              Add Vendor
              <i class="caption red--text ml-4"> * required field</i>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon @click="vendorPopup = false">mdi-close</v-icon>
          </v-toolbar>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <vendor id="0" @closePopup="closePopups()" @savepopup="savePopups" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import vendor from "@/components/front/Vendor/Details";

export default {
  components: { vendor },
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 2);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  data() {
    return {
      expiry_date: "",
      dateMenu: false,
      delivery_date: "",
      dateMenuTo: false,
      formData: {},
      loader: false,
      dialog: false,
      clientLoader: false,
      clients: [],
      vendors: [],
      currency: [],
      vendorLoader: false,
      next: false,
      fileLoader: false,
      ErrorMessage: [],
      file: null,
      vendorPopup: false,
      downloader: false,
      expireFiled: true,
      maxDateStr: "",
      currencyList: [],
    };
  },

  watch: {
    userRole() {
      if (this.userCategory.user_category === 3) this.fetchClientList();
    },
  },

  created() {
    // this.getCurrencyList();
    if (this.userCategory.user_category === 3) this.fetchClientList();
    if (this.$store.getters.user.user_category === 1) {
      this.fetchCurrency(this.$store.getters.user.id);
      this.fetchVendor();
    }
  },

  methods: {
    ...mapActions([
      "fetchClient",
      "snackBar",
      "getVendorsLists",
      "addInboundOrder",
      "downloadVendorTemplate",
      "fetchCurrencyList",
      "getCurrencyList",
    ]),

    changeDate() {
      const inputDate = new Date(this.delivery_date);
      const maxDate = new Date(inputDate);
      maxDate.setDate(inputDate.getDate());
      this.maxDateStr = maxDate.toISOString().split("T")[0];
      this.expireFiled = false;
    },
    reset() {
      this.formData = {};
      this.$refs.form?.reset();
      this.$router.push("/list-inbound-order");
    },
    downloadTemplate() {
      this.downloader = true;
      this.downloadVendorTemplate()
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    goToVendor() {
      this.vendorPopup = true;
    },
    fetchCurrency(id) {
      this.fetchCurrencyList(id)
        .then((res) => {
          this.currencyList = res.data;
        })
        .catch(() => {});
    },
    fetchVendor(id) {
      this.vendorLoader = true;
      let user_id = "";
      if (this.userCategory.user_category == 3) {
        user_id = id;
      } else {
        user_id = this.$store.getters.user.id;
      }
      this.getVendorsLists(user_id)
        .then((res) => {
          this.vendorLoader = false;
          this.vendors = res.data;
        })
        .catch(() => {
          this.vendorLoader = false;
        });
    },
    fetchClientList() {
      if (this.clients.length) return;
      this.clientLoader = true;
      this.fetchClient({
        fields: "id,name",
        service: "fulfillment,fulfillment_wid_last_mile",
      })
        .then((res) => {
          this.clientLoader = false;
          this.clients = res.data;
        })
        .catch(() => {
          this.clientLoader = false;
        });
    },
    savePopups(id) {
      this.vendorPopup = false;
      this.fetchVendor(id);
    },
    closePopups() {
      this.vendorPopup = false;
      this.reset();
    },
    async add() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.fileLoader = true;
      const payload = new FormData();
      payload.append(
        "vendor_invoice_number",
        this.formData.vendor_invoice_number
      );
      payload.append("vendor_code", this.formData.vendor_code);
      payload.append("currency_code", this.formData.currency_code);
      payload.append("client_id", this.formData.client_id);
      if (this.formData.additional_reference_number !== undefined) {
        payload.append(
          "additional_reference_number",
          this.formData.additional_reference_number
        );
      }
      payload.append("delivery_date", this.delivery_date);

      payload.append("data_file", this.file, this.file.name);

      await this.addInboundOrder(payload)
        .then((res) => {
          this.fileLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.$router.push("/list-inbound-order");
        })
        .catch((error) => {
          this.fileLoader = false;
          this.ErrorMessage = error.errors[0].message;
          this.dialog = true;
          this.snackBar({
            color: "error",
            message: error.errors[0].error_message,
          });
        });
    },
  },
};
</script>
